/* CHYRONYX — Navbar scroll-hide + mobile menu (replaces Navbar.tsx logic) */
(function(){
  var nav = document.querySelector('.chx-nav');
  var hbg = document.querySelector('.hbg');
  var mob = document.querySelector('.mob-menu');
  if (!nav) return;

  var lastY = 0;
  window.addEventListener('scroll', function(){
    var y = window.scrollY;
    var marquee = document.querySelector('.header-marquee');
    if (y > 55) nav.classList.add('scrolled');
    else nav.classList.remove('scrolled');
    if (y > lastY && y > 120) {
      nav.classList.add('nav-hidden');
      if(marquee) marquee.classList.add('nav-hidden');
    } else {
      nav.classList.remove('nav-hidden');
      if(marquee) marquee.classList.remove('nav-hidden');
    }
    lastY = y;
  }, {passive:true});

  if (hbg && mob) {
    hbg.addEventListener('click', function(){
      var isOpen = mob.classList.toggle('open');
      hbg.classList.toggle('open');
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });
    mob.querySelectorAll('a').forEach(function(a){
      a.addEventListener('click', function(){
        mob.classList.remove('open');
        hbg.classList.remove('open');
        document.body.style.overflow = '';
      });
    });
  }
})();
